import { useParams } from "react-router-dom";
import { useWallet } from '@txnlab/use-wallet';
import { Button } from '@/components/ui/button';

export function Account() {
  const { address } = useParams();
  const { activeAddress, activeAccount, providers, } = useWallet();

  const activeProvider = providers?.find(
    (provider) => provider.metadata.id === activeAccount?.providerId
  );

  return <>
    account {address}
    { address == activeAddress ? <>
      <Button variant="destructive" onClick={() => activeProvider?.disconnect()}>
        <img
          className="mr-3 -ml-2 rounded-full"
          width={26}
          height={26}
          alt={`${activeProvider?.metadata.name} icon`}
          src={activeProvider?.metadata.icon}
        />
        DISCONNECT
      </Button>
    </> : null }
  </>;
}